import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';


function FTPInstructions() {
    const users = useSelector(state => state.users);
    const user = useSelector(state => state.authentication.user);
    const dispatch = useDispatch();

    useEffect(() => {
        //dispatch(userActions.getAll());
    }, []);

    return (
    	<div>
        <div className="col-lg-12">
        	<h3>FTP Instructions</h3>
        </div>
        <div className="alert alert-secondary col-lg-12" role="alert">
            <strong>
            <p>All files FTP'd to NYSE must follow this naming convention: CS2Plus.xml</p> 
            <p>
                File names may not have spaces.<br/>
                Files should not be greater than 10MB in size.
            </p> 
            <p>
                FTP client  :  Use any client that supports FTP over SSL (explicit encryption - or "AUTH SSL") <br/>
                Nyse Host Name  :  cs2.ftp.efp.nyse.com<br/>
                Username  :  username@cs2.ftp.efp.nyse.com <br/>
            </p>
            </strong>
        </div>
        </div>

    );
}

export { FTPInstructions };